import { useEffect, useState } from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Credibility from './components/Credibility';
import OcrCapability from './components/OcrCapability';
import Trust from './components/Trust';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Prototypes from './components/Prototypes';

export default function App() {
  const [hash, setHash] = useState(() =>
    typeof window === 'undefined' ? '' : window.location.hash,
  );
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (hash.startsWith('#prototypes')) return <Prototypes />;

  return (
    <div className="min-h-screen bg-bg text-fg">
      <Nav />
      <main>
        <Hero />
        <Credibility />
        <OcrCapability />
        <Trust />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
